import React from "react";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import parse from 'html-react-parser';

import { checkPasswordComplexity, isValidName, isValidEmail, isValidPhone } from "../helpers/ccbhHelpers";

import '../content/base_2.0.css';
import '../content/ccbh-tableau-portal_2.0.css';
import { postUpdateUserFirstTimeLogin } from "../helpers/tableauAccountHelpers";
import { ccbhmessagebox, removeMsg } from "../scripts/ccbh.ui";
import { formatAsPhone } from "../scripts/ccbh";
import PageLogoHeader from "./pageLogoHeader";
import './firstTimeLogin.css';

function FirstTimeLogin () {
    let navigate = useNavigate();
   
    const firstNameErrorMessage = "First Name is not valid";    
    const lastNameErrorMessage = "Last Name is not valid";    
    const phoneErrorMessage = "Phone Number is not valid";
    const emailErrorMessage = "Email Address is not valid";
    const passwordErrorMessage = 'New Password and Confirm Password Do Not Match';

    const location = useLocation();
    
    const webuser = location.state?.loginResult?.user;

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [firstName, setFirstName] = useState(webuser.firstName);
    const [lastName, setLastName] = useState(webuser.lastName);
    const [phoneNumber, setPhoneNumber] = useState(webuser.phoneNumber);
    const [email, setEmail] = useState(webuser.email);
    const [disableSave, setDisableSave] = useState('disabled');
    const [passwordErrorMsg, setPasswordErrorMsg] = useState('');
    const [validUserInfo, setValidUserInfo] = useState(true);

    const setValidUserErrorMessage = (message, add) => {
        if(add === true){
            if(passwordErrorMsg === ''){
                setPasswordErrorMsg(message);
            }else if(passwordErrorMsg.includes(message)){
                setPasswordErrorMsg(passwordErrorMsg);//return
            }else{
                let msg = passwordErrorMsg + '<br /> ' + message;
                setPasswordErrorMsg(msg);
            }
        }else{
            let msg = passwordErrorMsg.replace(message, '');
            if (msg === '<br /> '){
                msg = '';
            }
            setPasswordErrorMsg(msg);
        }
        setValidUserInfo((passwordErrorMessage === ''));
    };

    const fetchUpdateUserInformation = async() =>{
        const response = await postUpdateUserFirstTimeLogin(webuser.authorization, webuser.webuserId, firstName, lastName, email, phoneNumber, password);
        if(response === 1 || response.errorCode === 0){
            ccbhmessagebox({
                message: "Your Information was successfully Updated.",
                title: "Account Information Update",
                modal: true,
                closebutton: false,
                buttons: {
                    'Ok': function(){
                        removeMsg();
                        navigate("/");
                    }
                }
            });
        }
    };

    const firstNameChange = event =>{
        setFirstName(event.currentTarget.value);
        if(!isValidName(event.currentTarget.value)){
            setValidUserInfo(false);
            setValidUserErrorMessage(firstNameErrorMessage, true);
        }else{
            setValidUserErrorMessage(firstNameErrorMessage, false);
        }
    };

    const lastNameChange = event => {
        setLastName(event.currentTarget.value);
        if(!isValidName(event.currentTarget.value)){
            setValidUserInfo(false);
            setValidUserErrorMessage(lastNameErrorMessage, true);
        }else{
            setValidUserErrorMessage(lastNameErrorMessage, false);
        }
    };

    const phoneChange = event => {
        if(!isValidPhone(event.currentTarget.value)){
            setValidUserInfo(false);
            setValidUserErrorMessage(phoneErrorMessage, true);
        }else{
            setValidUserErrorMessage(phoneErrorMessage, false);
            let ph = formatAsPhone(document.getElementById("ft-phone"));
            setPhoneNumber(ph);
            document.getElementById("ft-phone").value = ph;
        }
    };

    const emailChange = event => {
        setEmail(event.currentTarget.value);
        if(!isValidEmail(event.currentTarget.value)){
            setValidUserInfo(false);
            setValidUserErrorMessage(emailErrorMessage, true);
        }else{
            setValidUserErrorMessage(emailErrorMessage, false);
        }
    };

    const passwordChange = event => {
        const pwdCmplxErr = checkPasswordComplexity(event.currentTarget.value);
        if(pwdCmplxErr.length === 0){
            setPassword(event.currentTarget.value);
            setPasswordErrorMsg('');
            checkEnableSave(event.currentTarget.value, confirmPassword);
        }else{
            setPasswordErrorMsg('');

            let errMsg = '';
            pwdCmplxErr.forEach((e) => {
                errMsg += e.description + '<br />';
            });
            setPasswordErrorMsg(errMsg);
        }
    };

    const confirmPasswordChange = event => {
        setConfirmPassword(event.currentTarget.value);
        checkEnableSave(password, event.currentTarget.value);        
    };

    const checkEnableSave = (pwd, confPwd) => {
        if((pwd === confPwd) && (validUserInfo === true)){
            setPasswordErrorMsg('');
            setDisableSave('');
        }else{
            setPasswordErrorMsg(passwordErrorMessage);
            setDisableSave('disabled');
        }
    };

    useEffect(() => {
        let ph = formatAsPhone(document.getElementById("ft-phone"));
        setPhoneNumber(ph);
        document.getElementById("ft-phone").value = ph;
        },
    [2]);



    return(
        <>
        <PageLogoHeader />
        <input type="hidden" id="trustTicket" value="@TrustTicket" />
        <input type="hidden" id="usrname" value="@user.Username" />

        <div className="" id="first-time">
            <h2 id="">Welcome {webuser.firstName}, to DataMine</h2>
            <div className="">            
            <h2 id="update_account">Please update your account information where needed</h2>
            <br/>
            <div id="firstTime" name="firstTime" method="post">
                <div className="lbl-wrap">
                    <input type="text" id="ft-username" name="ft-username" readOnly disabled defaultValue={webuser.webuserId} />
                    <label htmlFor="username">username</label>
                </div>
                <br /><br />
                <div className="lbl-wrap">
                    <input type="text" id="ft-user-firstname" name="ft-user-firstname" defaultValue={firstName} onChange={firstNameChange} />
                    <label htmlFor="firstname">first name</label>
                </div>
                <br /><br />
                <div className="lbl-wrap">
                    <input type="text" id="ft-user-lastname" name="ft-user-lastname" defaultValue={lastName} onChange={lastNameChange} />
                    <label htmlFor="lastname">last name</label>
                </div>
                <br /><br />
                <div className="lbl-wrap">
                    <input type="tel" className="" id="ft-phone" name="ft-phone" defaultValue={phoneNumber} onChange={phoneChange} onBlur={phoneChange} pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" title="htmlFormat:123-456-7890" x-moz-errormessage="htmlFormat:123-456-7890" />
                    <label htmlFor="phone_number">phone number</label>
                </div>
                <br/><br/>
                <div className="lbl-wrap">
                    <input type="text" id="ft-email" name="ft-email" defaultValue={email} onChange={emailChange} title="Enter a valid email address" x-moz-errormessage="Please enter a valid email address" required />
                    <label htmlFor="email">email address</label>
                </div>
                <br /><br />
                <div className="lbl-wrap" id="password-first-time">
                    <input type="password" id="ft-password" name="ft-password" defaultValue={password} autoComplete="new-password" onChange={passwordChange}/>
                    <label htmlFor="password">password</label>
                </div>
                <br /><br />
                <div className="lbl-wrap" id="confirm-first-time">
                    <input type="password" id="ft-password-confirm" name="ft-password-confirm" defaultValue="" autoComplete="off" onChange={confirmPasswordChange} />
                    <label htmlFor="password-confirm">confirm password</label>
                </div>
                <br /><br />
                
                <div className="lbl-wrap-error">
                    <label className="errMsg">{parse(passwordErrorMsg)}</label>
                </div>
                <br /><br />

                <div className="error-section" id="firstime-error-div">
                    <h2 className="">Please Correct The Following Errors:</h2>
                    <label id="page-errors" className=""></label><br/>
                </div>
                
                <input type="button" id="update_account_info" name="update_account_info" defaultValue="Save" onClick={fetchUpdateUserInformation} disabled={disableSave}/>
                
            </div>
            <br/><br/>
            </div>
        </div>
        </>
    );

};

export default FirstTimeLogin;


